<button #dropDown type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside"
  class="w-100 text-start bg-transparent border-0 p-0" (click)="addFocus()">
  <div class="lp-header d-flex align-items-center gap-2 mb-1">
    <ng-content select="[location-picker-icon]"></ng-content>
    <span class="form-label fs-14 text-default mb-0">{{ label }}</span>
  </div>
  <h5>
    {{ selectedLocation ? (selectedLocation.city || selectedLocation.name || 'Select location') : 'Select location' }}
  </h5>
  <p class="fs-12 mb-0">
    {{ selectedLocation?.code ? selectedLocation?.code + ', ' : '' }}
    {{ selectedLocation?.name || '' }}
  </p>
</button>
<div class="dropdown-menu dropdown-md p-0 location-picker-menu">
  <!-- top header (visible on mobile as a sheet header) -->
  <div class="lp-menu-header d-flex align-items-center justify-content-between p-3 border-bottom">
    <h5 class="mb-0">Select City or Location</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeDropDown(dropDown)"></button>
  </div>

  <div class="input-search p-3 border-bottom">
    <div class="input-group">
      <input #searchInput type="text" class="form-control" placeholder="Search Location"
        [formControl]="searchInputControl" />
      <span class="input-group-text px-2 border-start-0"><i class="isax isax-search-normal"></i></span>
    </div>
  </div>

  <!-- Loader Section (Added) -->
  <!-- Skeleton Loader -->
  <div *ngIf="isLoading" class="skeleton-wrapper p-3">
    <div class="skeleton-item mb-3" *ngFor="let item of [1,2,3,4]">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div class="skeleton-title mb-2"></div>
          <div class="skeleton-text"></div>
        </div>
        <div class="skeleton-code"></div>
      </div>
    </div>
  </div>


  <!-- No Data Found -->
  <div class="lp-empty" *ngIf="
    !isLoading &&
    searchInputControl.value?.length >= 3 &&
    locations.length === 0
  ">
    <div class=" text-center">
      <p class="text-muted mb-0">No data found</p>
    </div>
  </div>
  <!-- empty / placeholder area when there are no results or input is less than min chars -->
  <div class="lp-empty" *ngIf="locations.length === 0 && !isLoading">
    <div class="p-3">
      <a class="d-flex align-items-center text-primary mb-3" href="javascript:void(0)"
        (click)="useCurrentLocation(dropDown)">
        <i class="isax isax-locate me-2"></i>
        Use Current Location
      </a>
      <hr />
      <p class="text-muted mb-0">Enter 3 or more characters to search</p>
    </div>
  </div>

  <!-- Main Content (Shown only when data loaded) -->
  <div *ngIf="!isLoading">
    <ul>
      <li class="border-bottom" *ngFor="let location of locations">
        <a class="dropdown-item" href="javascript:void(0);" (click)="setLocation(location, dropDown)">
          <div class="d-flex justify-content-between">
            <div>
              <h5 class="fs-16 fw-medium">{{ location.city }}, {{ location.country }}</h5>
              <p>{{ location.name }}</p>
            </div>
            <span class="max-content">{{ location.code }}</span>
          </div>
        </a>
      </li>
    </ul>
  </div>
</div>
